import type { MouseEvent } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Avatar } from '../../../Avatar';
import type { CommunicationPatientRef } from '../../../../services/communications';

interface LinkedPatientRowProps {
    patient: CommunicationPatientRef;
    onRemove: () => void;
}

// preventDefault + stopPropagation so unlinking doesn't navigate.
export function LinkedPatientRow({ patient, onRemove }: LinkedPatientRowProps) {
    const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove();
    };

    return (
        <a
            href={`/patients/${patient.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2.5 w-full h-11 px-2.5 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
        >
            <div className="w-7 h-7 shrink-0">
                <Avatar
                    user={{ name: patient.name, email: '' }}
                    thumbnailURL={patient.profileThumbnailUrl ?? undefined}
                />
            </div>
            <span
                title={patient.name}
                className="flex-1 min-w-0 text-[13px] font-semibold text-gray-800 truncate"
            >
                {patient.name}
            </span>
            <button
                type="button"
                onClick={handleRemove}
                aria-label={`Unlink ${patient.name}`}
                className="shrink-0 p-1 rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
            >
                <XMarkIcon className="h-3.5 w-3.5" />
            </button>
        </a>
    );
}
